import * as yup from "yup";

export type LinklyPairFormValues = {
  name: string;
  username: string;
  password: string;
  pairCode: string;
  paymentMethodId: string;
};

export const schema = yup.object().shape({
  name: yup.string().required(),
  username: yup.string().required(),
  password: yup.string().required(),
  pairCode: yup.string().required(),
  paymentMethodId: yup.string().required(),
});
